import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from '@material-ui/core';
import Authorize from 'components/Authorize';
import { permissionProfiles } from 'components/Authorize/permissionProfiles';
import { IconAccessCode } from 'icons';
import { useEffect, useState } from 'react';
import { CreateTenantStyles } from "./styles";
import { useCreateTenantMutation } from '../tenantSlice';
import NotificationProvider from 'components/NotificationProvider';

const CreateTenant = ({ }) => {

    const classes = CreateTenantStyles();

    let [addTenant, { isLoading: isSaving }] = useCreateTenantMutation();

    const [dialogOpen, setDialogOpen] = useState(false);
    const [formData, setFormData] = useState({
        tenantName: '',
        clientName: '',
        clientAccountName: '',
        pmfSupportPassword: ''
    });

    const validate = () => {
        if (!formData.tenantName || !formData.clientName || !formData.clientAccountName || !formData.pmfSupportPassword) {
            return false;
        }
        return true;
    }

    const onSave = async () => {
        if (!validate()) return;
        const res = await addTenant(formData);
        if (res.error) {
            console.log(res)
            NotificationProvider.error(`Failed to save tenant: ${res.error?.data?.messages?.join(" ")}`);
        } else {
            NotificationProvider.success("Saved tenant successfully");
        }
    }


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    useEffect(() => {
        if (dialogOpen) {
            setFormData({
                tenantName: '',
                clientName: '',
                clientAccountName: '',
                pmfSupportPassword: ''
            });
        }
    }, [dialogOpen]);

    return (
        <Authorize profile={permissionProfiles.SAAS_MANAGEMENT.MANAGE_TENANTS}>
            <>
                <Button
                    variant='contained'
                    color="primary"
                    onClick={() => setDialogOpen(true)}
                >
                    Create Tenant
                </Button>
                <Dialog
                    open={dialogOpen}
                    onClose={() => { }}
                    fullWidth
                    maxWidth='sm'>
                    <DialogTitle>{`Create Tenant`}</DialogTitle>
                    <DialogContent>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <label className={classes.fieldLabel}>
                                    Tenant Name
                                    <TextField
                                        error={!formData.tenantName}
                                        required
                                        fullWidth
                                        variant="outlined"
                                        name="tenantName"
                                        value={formData.tenantName}
                                        onChange={handleInputChange}
                                    />
                                </label>
                            </Grid>
                            <Grid item xs={12}>
                                <label className={classes.fieldLabel}>
                                    Default Client Name
                                    <TextField
                                        error={!formData.clientName}
                                        required
                                        fullWidth
                                        variant="outlined"
                                        name="clientName"
                                        value={formData.clientName}
                                        onChange={handleInputChange}
                                    />
                                </label>
                            </Grid>
                            <Grid item xs={12}>
                                <label className={classes.fieldLabel}>
                                    Default Client Account Name
                                    <TextField
                                        error={!formData.clientAccountName}
                                        required
                                        fullWidth
                                        variant="outlined"
                                        name="clientAccountName"
                                        value={formData.clientAccountName}
                                        onChange={handleInputChange}
                                    />
                                </label>
                            </Grid>
                            <Grid item xs={12}>
                                <label className={classes.fieldLabel}>
                                    PMF Support Password
                                    <TextField
                                        error={!formData.pmfSupportPassword}
                                        required
                                        fullWidth
                                        variant="outlined"
                                        name="pmfSupportPassword"
                                        value={formData.pmfSupportPassword}
                                        onChange={handleInputChange}
                                    />
                                </label>
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            color="secondary"
                            variant="outlined"
                            onClick={() => setDialogOpen(false)}>
                            Cancel
                        </Button>
                        <Button
                            color="primary"
                            variant="outlined"
                            onClick={onSave}
                            disabled={isSaving || !validate()}
                        >
                            {isSaving ? 'Saving...' : 'Save'}
                        </Button>
                    </DialogActions>
                </Dialog>
            </>
        </Authorize>
    );
}

export default CreateTenant;